/* eslint-disable no-undef */
import { VRProp } from './props.js';

export class VRCustomOverlay extends VRProp {
  static count = 0;

  static defaultOptions = {
    size: 400,
    color: '#ffffff',
    shadow: false,
    type: 'custom-overlay'
  };

  constructor (vr, scene, options) {
    super(vr, scene, $.extend({}, VRCustomOverlay.defaultOptions, options));
    this.vr = vr;
    this.count = VRCustomOverlay.count;
    if (!this.options.id) {
      this.options.id = 'custombanner_' + this.count;
    }

    if (this.scaleX === undefined) {
      this.scaleX = 1;
    }

    if (this.scaleY === undefined) {
      this.scaleY = 1;
    }

    this.div.addClass('ca-vr_custom-banner');
    this.div.addClass('ca-vr_custom-overlay' + this.count);

    this.img.remove();

    this.bannerContainer = $('<div class="ca-vr_custom-overlay_banner-container"></div>');
    this.bannerContainer.css('width', '100%');
    this.bannerContainer.css('height', '100%');
    this.bannerContainer.css('background-color', 'white');
    this.bannerContainer.css('display', 'inline-block');
    this.assetContainer.append(this.bannerContainer);

    this.boardImgContainer = $(
      '<div class="ca-vr_overlay_boardimg_container"></div>'
    );

    this.bannerContainer.append(this.boardImgContainer);

    VRCustomOverlay.count++;
    this.div.on(
      'dragover',
      function (e) {
        e.preventDefault();
      }
    );

    this.div.on(
      'dragenter',
      function (e) {
        e.preventDefault();
        this.showDropHint(true);
      }.bind(this)
    );

    this.div.on(
      'dragleave',
      function (e) {
        e.preventDefault();
        this.showDropHint(false);
      }.bind(this)
    );

    this.initializeCustomOverlay();

    if (!this.options.propId) {
      this.setAsset(vr.assets.boards[0]);
    } else {
      this.setAsset(this.vr.getBoardAsset(this.options.propId));
    }
  }

  initializeCustomOverlay () {
    // call init board image
    if (this.options.image) {
      this.initBoardImage();
    }
    // set scale
    if (this.boardImg !== undefined) {
      if (this.options.height !== undefined) {
        this.boardImg.height(this.options.height);
      } else {
        this.boardImg.height(this.size);
      }

      if (this.boardImg.width !== undefined) {
        this.boardImg.width(this.options.width);
      } else {
        this.boardImg.width(this.size);
      }

      // set out background options
      if (this.options.backgroundDisplayType !== undefined) {
        this.boardImg.css('background-size', this.options.backgroundDisplayType);
        this.boardImg.css('background-repeat', 'no-repeat');
        this.boardImg.css('background-position', 'center');
      }
    } else {
      this.assetContainer.width(this.options.size);
      this.assetContainer.height(this.options.size);
    }
  }

  initBoardImage () {
    this.boardImg = $('<img class="ca-vr_overlay_boardimg" />');
    this.boardImg.on(
      'load',
      function () {
        // this.aspectRatio =
        //     this.boardImg[0].naturalWidth / this.boardImg[0].naturalHeight;
        // this.refreshAssetWithImage(this.vr.getBoardAsset(this.options.propId));
      }
    );
    this.boardImg.attr('draggable', false);
    if (this.options.image.url) {
      this.setMedia(this.options.image.url, this.options.image.type);
    }
    if (this.options.image.width) {
      this.boardImg.width(this.options.image.width);
    }
    this.boardImgContainer.append(this.boardImg);
  }

  moveBy (x, y) {
    super.moveBy(x, y);
    this.move(
      this.mouseDownTopLeftYawPitch.yaw - x,
      this.mouseDownTopLeftYawPitch.pitch + y
    );
  }

  getPropId () {
    return this.options.propId;
  }

  setBackgroundDisplayType (displayTypeValue) {
    this.boardImg.css('background-size', displayTypeValue);
    this.boardImg.css('background-repeat', 'no-repeat');
    this.boardImg.css('background-position', 'center');
    this.options.backgroundDisplayType = displayTypeValue;
  }

  setBannerHeight (heightValue) {
    this.boardImg.height(heightValue);
    this.options.height = heightValue;
  }

  setBannerWidth (widthValue) {
    this.boardImg.width(widthValue);
    this.options.width = widthValue;
  }

  setMedia (url, type) {
    if (!this.options.image) {
      this.options.image = {};
      this.initBoardImage();
    }
    this.options.image.url = this.parseImageUrl(url);
    if (type !== undefined) {
      this.options.image.type = type;
    }
    if (this.options.image.type !== undefined) {
      if (this.options.image.type === 'image') {
        this.boardImg.css('background', `url(${this.options.image.url})`);
        this.boardImg.css('background-position', 'center');
      } else {
        this.boardImg.css('background', `url(${this.options.image.url}&p=thumb)`);
        this.boardImg.css('background-position', 'center');
      }
    } else {
      this.boardImg.css('background', `url(${this.options.image.url})`);
      this.boardImg.css('background-position', 'center');
    }

    // this.setMediaAlignment();
  }

  // might need to rid myself of the logic below because we're gonna want a loooooooong banner
  parseImageUrl (image) {
    if (image.includes('media.caapp.com.au')) {
      return image + '?w=600';
    }
    return image;
  }
}
